"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ITEM_INVALID = void 0;
exports.MOCK_CART_ITEM_INVALID = {
    productDiscounts: [],
    productContent: {
        displayName: 'MEDIUM SIM PLAN',
    },
    sku: 'sim40monthly',
    cartItemId: '12467',
};
//# sourceMappingURL=cart-item-invalid.mock.js.map